import { Box, Button, TextField, MenuItem, Typography } from "@mui/material";

export default function UpdateProductForm({
  productData,
  isSingleProduct,
  selectedCount,
  productTypes,
  empresaRubro,
  setEditMethod,
  sellMethod,
  setSellMethod,
  quantityReference,
  unit,
  setUnit,
  handleReferenceChange,
  handleUnitChange,
  handleChange,
  handleSubmit,
  editMethod,
}) {
  const isServicio = empresaRubro === "Servicios";

  if (selectedCount === 0) {
    return (
      <Box
        sx={{
          ml: 1.4,
          mt: 1,
          width: "87.2%",
          padding: 2,
          border: "1px solid #ccc",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {isServicio
          ? "Seleccione uno o más servicios para editar"
          : "Seleccione uno o más productos para editar"}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ml: 1.4,
        mt: 1,
        width: "87.2%",
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Typography sx={{ mb: 1 }}>
        {isServicio
          ? isSingleProduct
            ? "Actualizar servicio"
            : `Actualizar ${selectedCount} servicios`
          : isSingleProduct
          ? "Actualizar producto"
          : `Actualizar ${selectedCount} productos`}
      </Typography>

      {editMethod ? (
        <>
          <TextField
            select
            label="Método de venta"
            value={sellMethod}
            onChange={(e) => setSellMethod(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          >
            <MenuItem value="Unidad">Unidad</MenuItem>
            <MenuItem value="Decimal">Decimal</MenuItem>
          </TextField>

          {sellMethod === "Decimal" && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="Referencia"
                type="number"
                width="40%"
                value={unit === "kg" ? quantityReference / 1000 : quantityReference}
                onChange={handleReferenceChange}
                
              />
              <TextField
                select
                label="Unidad"
                value={unit}
                onChange={handleUnitChange}
                sx={{ width: "20%" }}
              >
                <MenuItem value="gr">gr</MenuItem>
                <MenuItem value="kg">kg</MenuItem>
              </TextField>
            </Box>
          )}

          <Button
            variant="outlined"
            color="primary"
            onClick={() => setEditMethod(false)}
            sx={{ mt: 2 }}
          >
            Volver al formulario
          </Button>
        </>
      ) : (
        <>
          {isSingleProduct && (
            <>
              <TextField
                label="Nombre"
                value={productData.name || ""}
                onChange={handleChange}
                fullWidth
                margin="normal"
                name="name"
              />
              <TextField
                select
                margin="dense"
                label={isServicio ? "Tipo de servicio" : "Tipo de producto"}
                fullWidth
                name="type"
                value={productData.type}
                onChange={handleChange}
                sx={{ marginBottom: 1 }}
              >
                {productTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.type}
                  </MenuItem>
                ))}
              </TextField>

              <Button
                variant="outlined"
                onClick={() => setEditMethod(!editMethod)}
                sx={{ mb: 1 }}
              >
                {editMethod
                  ? "Volver al formulario"
                  : sellMethod === "Unidad"
                  ? "Método de venta: Por unidad"
                  : `Método de venta: Por ${
                      unit === "kg"
                        ? `${(quantityReference / 1000).toFixed(1)} kg`
                        : `${quantityReference} gr`
                    }`}
              </Button>
            </>
          )}
        </>
      )}

      <TextField
        label={isSingleProduct ? "Precio" : "Porcentaje de aumento"}
        type="number"
        value={productData.price}
        onChange={handleChange}
        fullWidth
        margin="normal"
        name="price"
      />

      <Button
        variant="contained"
        color="success"
        onClick={handleSubmit}
        disabled={!productData.price}
        sx={{ mt: 1, width: "100%" }}
      >
        Guardar cambios
      </Button>
    </Box>
  );
}
